import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService } from '../../services/notification.service';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-notification-center',
    imports: [CommonModule, DialogModule, ButtonModule],
    templateUrl: './notification-center.component.html',
    styleUrl: './notification-center.component.scss'
})
export class NotificationCenterComponent {
  notifications: any[] = [];
  showDetail = false;
  selectedNotification: any = {};
  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();

  constructor(private serviceNotification: NotificationService) {}

  ngOnInit() {
    this.getNotifications();
  }

  getNotifications() {
    this.serviceNotification.getNotifications().subscribe({
      next: (resp: any) => { this.notifications = resp; },
      error: () => { this.notifications = []; }
    });
  }

  showInfoNotification(notification: any) {
    this.selectedNotification = notification;
    this.showDetail = true;
  }
}
